import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import { ArrowRight } from "lucide-react";

const ACCENTS = ["primary", "info", "warning", "success"];

// Same blog ko hamesha same color milega (title/slug se pick hota hai)
function pickAccent(seed = "") {
  let sum = 0;
  for (let i = 0; i < seed.length; i++) sum += seed.charCodeAt(i);
  return ACCENTS[sum % ACCENTS.length];
}

function getInitials(name = "") {
  return name
    .replace(/^dr\.?\s+/i, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}

function Card({ item }) {
  const accent = pickAccent(item?.slug || item?.title || "");
  const category =
    typeof item?.category === "object" ? item?.category?.name : item?.category;
  const author = item?.author || "Ivoréa Team";

  return (
    <Link
      to={`/blog/${item?.slug}`}
      className={`bc-card bc-${accent}`}
    >
      {/* Top visual */}
      <div className="bc-visual">
        {item?.image && (
          <img src={item.image} alt={item?.title || ""} loading="lazy" />
        )}
        <span className="bc-dots" aria-hidden="true" />
        {item?.tag && <span className="bc-tag">{item.tag}</span>}
      </div>

      {/* Body */}
      <div className="bc-body">
        {category && <span className="bc-category">{category}</span>}

        <h4 className="bc-title">{item?.title}</h4>
        <p className="bc-excerpt">{item?.shortDescription}</p>

        <div className="bc-footer">
          <div className="bc-author-row">
            <div className="bc-avatar">{getInitials(author)}</div>
            <div className="bc-author-info">
              <div className="bc-author-name">{author}</div>
              <div className="bc-meta">
                {item?.date ? getDateAgo(item.date) : ""}
                {item?.date && item?.readTime ? " · " : ""}
                {item?.readTime || ""}
              </div>
            </div>
          </div>

          <span className="bc-arrow">
            <ArrowRight size={13} />
          </span>
        </div>
      </div>
    </Link>
  );
}

export default Card;